import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=38e00c96"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e00c96')) {
      api.createRecord('38e00c96', component.options)
    } else {
      api.reload('38e00c96', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=38e00c96", function () {
      api.rerender('38e00c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/demo.vue"
export default component.exports